import React, { useState } from "react";
import { Copyright, Home } from "@mui/icons-material";
import RegisterBookContent from "../../../../../components/reg_book/RegisterBookContent";
import { useGetRegBookCopyrightQuery } from "../../../../../redux/api/submittedCopyrightAgreementApiSlice";
import Loader from "../../../../../components/custom/Loader";
import CopyrightTable from "../../../../../components/reg_book/CopyrightTable";

const RecordedBookCopyright = () => {
  const bookType = 3;
  const [trackReg, setTrackReg] = useState("");
  const { data, isLoading } = useGetRegBookCopyrightQuery({
    bookType,
    trackReg,
  });
  const breadcrumbsData = [
    { icon: Home, title: "হোম", url: "/" },
    {
      icon: Copyright,
      title: "কপিরাইট - নথিজাত রেজিস্টার বুক",
      active: true,
    },
  ];
  const applicationPath = {
    copyright: "/admin/recorded-register-book-copyright",
    agreement: "/admin/recorded-register-book-agreement",
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <RegisterBookContent
      data={data}
      trackReg={trackReg}
      setTrackReg={setTrackReg}
      content={<CopyrightTable data={data} />}
      breadcrumbsData={breadcrumbsData}
      applicationPath={applicationPath}
    />
  );
};

export default RecordedBookCopyright;
